import { Route, Routes } from "react-router-dom";
import DocterDetailsScreen from "./MobileComponents/DocterDetailsScreen/DocterDetailsScreen";
import HomeScreen from "./MobileComponents/HomeScreen/HomeScreen";
import YourBookings from "./MobileComponents/YourBookings/YourBookings";
import CheckOutPage from "./MobileComponents/CheckOutPage/CheckOutPage";
import BookingDonePage from "./MobileComponents/BookingDonePage/BookingDonePage";
import PatientsDetailsForm from "./MobileComponents/PatientsDetailsForm/PatientsDetailsForm";
import Login from "./MobileComponents/AuthenticationPages/Login/Login";
import CreateProfileForm from "./MobileComponents/CreateProfileForm/CreateProfileForm";
import AuthProvider from "./MobileComponents/context/AuthContext";
import AppBar from "./MobileComponents/AppBar/AppBar";
import MyProfile from "./MobileComponents/MyProfile/MyProfile";
import PrivateRoute from "./MobileComponents/context/PrivateRoute";
import MedicineNotifier from "./MobileComponents/MedicineNotifier/MedicineNotifier";
import MapsLocatorPage from "./MobileComponents/HomeScreen/components/MapsLocatorPage";
import { AppContextProvider } from "./MobileComponents/context/AppContext";
import AppSnackbar from "./MobileComponents/AppSnackbar";
import SearchLocationPage from "./MobileComponents/HomeScreen/HomeLocation/SearchLocationPage/SearchLocationPage";
import TermsAndConditions from "./MobileComponents/Guidelines/TermsAndConditions/TermsAndConditions";
import PrivacyPolicy from "./MobileComponents/Guidelines/PrivacyPolicy/PrivacyPolicy";
import VideoCallPage from "./MobileComponents/VideoCall/VideoCallPage";
import FeedbackScreen from "./MobileComponents/Feedback/FeedbackScreen";
import PublicSurveyScreen from "./MobileComponents/Feedback/PublicSurveyScreen";

function App() {
  return (
    <>
      <AuthProvider>
        <AppContextProvider>
          {/* Responsive shell: centred column on tablets/desktops (src/index.css) */}
          <div className="mhv-shell">
          <Routes>
            {/* HOME (MHV) TAB */}
            <Route path="/" element={<HomeScreen />} />
            <Route path="/login" element={<Login />} />
            <Route path="/createprofile" element={<CreateProfileForm />} />
            <Route
              path="/docterdetails/:id"
              element={<DocterDetailsScreen />}
            />
            <Route
              path="/checkout"
              element={<PrivateRoute component={<CheckOutPage />} />}
            />
            <Route
              path="/bookingdetailsform"
              element={<PrivateRoute component={<PatientsDetailsForm />} />}
            />
            <Route
              path="/Bookingdone"
              element={<PrivateRoute component={<BookingDonePage />} />}
            />
            <Route
              path="/Bookingdone"
              element={<PrivateRoute component={<BookingDonePage />} />}
            />
            <Route
              path="/myprofile"
              element={<PrivateRoute component={<MyProfile />} />}
            />
            {/* Patient feedback & complaints (NABH AAC.6.a) — PATIENT_FEEDBACK.md §8 */}
            {/* Logged-out survey link / clinic QR (NABH AAC.6.a Steps 16–17) */}
            <Route path="/survey" element={<PublicSurveyScreen />} />
            <Route
              path="/feedback"
              element={<PrivateRoute component={<FeedbackScreen />} />}
            />
            {/* BOOKINGS TAB */}
            <Route
              path="/bookings"
              element={<PrivateRoute component={<YourBookings />} />}
            />
            <Route path="/medicine" element={<MedicineNotifier />} />
            <Route path="/maps" element={<MapsLocatorPage />} />
            <Route path="/searchLocation" element={<SearchLocationPage />} />
            <Route
              path="/termsandcondition"
              element={<TermsAndConditions />}
            />{" "}
            <Route path="/privacypolicies" element={<PrivacyPolicy />} />
            {/* NABH COP.7.a — the emailed consultation link lands here. Behind
                the guard so a logged-out patient gets the login screen and is
                returned to the call, instead of a bare "unable to start" error
                from the 401. */}
            <Route
              path="/video-call"
              element={<PrivateRoute component={<VideoCallPage />} />}
            />
          </Routes>
          </div>
          <AppBar />
          <AppSnackbar />
        </AppContextProvider>
      </AuthProvider>
    </>
  );
}

export default App;
